import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GfTranslateService } from '../../../services/core.translate.service';
import { ProjectService } from '../../../services/project.service';
import { ProjectModel } from '../../../services/project.model.service';
import { UiService } from '../../../services/core.ui.service';
import { UserService } from '../../../services/core.user.service';
import { StateService } from '@uirouter/angular';
import { BreadcrumbService } from '../../../../widgets/breadcrumbs/breadcrumbs.service';

import * as _ from 'lodash';
import { GfTitleService } from '../../../services/core.title.service';
import { getFullName } from '../../../pipes/user/user.functions';

@Component({
    selector: 'project-team',
    template: require('./project.team.component.html'),
})
export class ProjectTeamComponent implements OnInit {

    @Input() project: any = null;

    private unixName = '';
    private options: any = {
        role: '',
        search: '',
        page_size: 50
    };

    protected isOrg = false;
    private members = null;
    private inviteRoleName = '';
    private page_size = 20;
    private page_num = 1
    private memberfilter = '';
    private groups = { includeGroups: false };
    protected roles = [];
    private selectedRole = null;
    private invites: any = {};
    protected activeTab = 'members';
    private loading = true;
    protected removeFromAll = false;

    private breadcrumbs = [];

    private invitesPage = 1;
    private invitedUsers: any = null;
    private joinRequestPage = 1;
    private joinRequests: any = null;
    private inviteRole = null;
    private sessionIsSiteAdmin = false;

    protected cancelInvitationUser = null;
    protected removeUser: any = null;
    protected rejectRequest = null;

    protected acceptProjectRole = null;
    protected acceptProjectRequest: any = null;

    protected parentCtrl = this;

    constructor(
        private projectService: ProjectService,
        private projectModel: ProjectModel,
        private uiService: UiService,
        private stateService: StateService,
        private breadcrumbService: BreadcrumbService,
        private $http: HttpClient,
        private $window: Window,
        private gfTranslateService: GfTranslateService,
        private titleService: GfTitleService,
        private userService: UserService,
    ) { }

    // Helper method to generate href for current state with different params
    getCurrentStateHref(params: any): string {
        return this.stateService.href('.', params);
    }

    switchTab(view: string): void {
        this.activeTab = view;
        this.stateService.go('.', { view, page_num: 1, page_size: 20 }, { notify: false });
    }

    ngOnInit(): void {

        const unixName = this.project.unixName;
        this.sessionIsSiteAdmin = this.userService.session.isSiteAdmin();

        this.options = {
            role: this.stateService.params.role,
            search: this.stateService.params.search,
            page_size: 50
        };

        this.inviteRoleName = this.gfTranslateService.translate('Roles') + '...';
        this.page_size = _.get(this.stateService.params, 'page_size', 20);
        this.page_num = _.get(this.stateService.params, 'page_num', 1);
        this.memberfilter = _.get(this.stateService.params, 'search', '');
        this.groups = { includeGroups: _.get(this.stateService.params, 'groups', 'false') };
        this.activeTab = _.get(this.stateService.params, 'view', 'members');

        this.titleService.setTitle(this.project.name, 'Team');

        this.breadcrumbs = [
            {
                label: _.get(this.project, 'name', ''),
                state: 'home.project.summary',
                params: { unixName: unixName }
            },
            {
                label: this.gfTranslateService.translate('Team')
            }
        ];

        this.breadcrumbService.setCrumbs(this.breadcrumbs);

        this.getInvites(this.options);
        this.getJoinRequests(this.options);

        this.projectModel.loadProjectRoles(unixName)
            .then((data: any) => {
                this.roles = _.sortBy(data, 'roleName');
                this.selectedRole = this.roles.find((item) => {
                    return item.id == this.stateService.params.role;
                });

                this.loadProjectMembers()
                    .then(() => {
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                        var msg = this.gfTranslateService.translate('There was a problem loading project members: {{unixName}}',
                            { 'unixName': unixName });
                        this.uiService.message.showWarning(msg, 'Data Error');
                    });
            });

        this.isOrg = this.projectModel.isOrg(this.project);
    };

    private selectRole = (role) => {
        if (!this.selectedRole || role?.id != this.selectedRole.id) {
            this.selectedRole = role;
        }
    }

    private filterMembers = (q) => {
        if (!q) q = '';
        var params = {
            search: q,
            role: _.get(this.selectedRole, 'id', ''),
            groups: this.groups.includeGroups,
            page_num: 1
        };
        this.stateService.go('.', params, { notify: true })
            .then(() => {
                this.updateMembersList();
            });

    };

    private onpage = (params) => {
        this.stateService.go('.', _.extend(this.stateService.params, params), { notify: true });
        this.updateMembersList();
    };

    private changeInvitesPage = (number) => {
        this.invitesPage = number;
        this.updateInvitesList();
    };

    private changeJoinRequestPage = (number) => {
        this.joinRequestPage = number;
        this.updateJoinRequestList();
    };

    private setInviteValues = (rolId, roleName) => {
        this.inviteRoleName = roleName;
        this.inviteRole = rolId;
    };

    private cancelInvitation = (user) => {
        this.cancelInvitationUser = user;
        ($('#cancelInvitationModal') as any).modal('show');
    };

    protected cancelInvitationConfirm = () => {
        ($('#cancelInvitationModal') as any).modal('hide');

        var user = this.cancelInvitationUser;
        var settingName = 'invite:' + user.token;

        this.projectService.cancelInvitation(
            user.refId,
            settingName
        ).then(
            () => {
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate('Cancelled the invitation to {{userEmail}}',
                        this.cancelInvitationUser),
                    'Cancel Invitation'
                );
                this.cancelInvitationUser = false;
            },
            (reject) => {
                console.log(reject);
                var msg = this.gfTranslateService.translate('Sorry, could not cancel the invitation to {{userEmail}}',
                    this.cancelInvitationUser
                );
                this.uiService.message.showWarning(msg, 'Data error');
                this.cancelInvitationUser = false;
            }
        ).finally(() => {
            this.invitesPage = 1;
            this.updateInvitesList();
        });
    };

    private removeMember = (member) => {
        if (this.shouldDisableRemove(member)) {
            const msg = this.gfTranslateService.translate('Only site administrators can remove members that belong to groups.');
            this.uiService.message.showWarning(msg, this.gfTranslateService.translate('Permission Denied'));
            return;
        }
        this.removeUser = member;
        ($('#removeMemberModal') as any).modal('show');
    };

    protected hasGroups = (member) => {
        return (_.get(member, 'groups', [])?.length > 0);
    };

    protected memberGroups = (member) => {
        return _.map(
            _.get(member, 'groups', []),
            (group) => { return group.firstname; }
        ).join(',');
    };

    private shouldDisableRemove = (member) => {
        if (!member) return false;
        if (!this.hasGroups(member)) return false;
        return !this.sessionIsSiteAdmin;
    };

    private canRemoveMember = (member) => {
        return !this.shouldDisableRemove(member);
    };

    protected removeMemberConfirm = () => {
        ($('#removeMemberModal') as any).modal('hide');
        var params = {
            unixName: this.project.unixName,
            memberId: this.removeUser.id,
            org: this.removeFromAll ? true : null
        };

        this.projectService.removeMember(
            this.project.unixName,
            this.removeUser.id,
            this.removeFromAll ? true : null
        ).then(
            () => {
                var msg = this.gfTranslateService.translate(
                    '{{unixName}} has been removed from the project',
                    this.removeUser
                );
                this.uiService.message.showSuccess(msg);
                this.removeUser = false;
                this.page_num = 1;
                this.updateMembersList();
            },
            (error) => {
                // Check for 403 Forbidden status
                if (error && error.status === 403) {
                    var msg = this.gfTranslateService.translate(
                        'The user cannot be removed from this project. You do not have permission to remove the user from at least one of the groups the user is in.',
                    );
                    this.uiService.message.showWarning(msg, 'Permission Denied');
                } else {
                    var msg = this.gfTranslateService.translate(
                        'There was a problem removing {{unixName}}.',
                        this.removeUser
                    );
                    this.uiService.message.showWarning(msg, 'Data error');
                }
                this.removeUser = false;
            }
        );
    };

    private rejectJoinRequest = (pjr) => {
        this.rejectRequest = pjr;
        ($('#rejectRequestModal') as any).modal('show');
    };

    protected rejectRequestConfirm = () => {
        ($('#rejectRequestModal') as any).modal('hide');
        var userName = getFullName(this.rejectRequest.user);
        this.projectService.rejectRequest(
            this.project.unixName,
            this.rejectRequest.user.id
        ).then(
            () => {
                var msg = this.gfTranslateService.translate('Reject the request from {{userName}}', { 'userName': userName });
                this.uiService.message.showSuccess(msg);
                this.rejectRequest = false;
                this.joinRequestPage = 1;
                this.updateJoinRequestList();
            },
            () => {
                var msg = this.gfTranslateService.translate('There was a problem rejecting the join request from {{userName}}',
                    { 'userName': userName });
                this.uiService.message.showWarning(msg, 'Data error');
                this.rejectRequest = false;
            }
        );
    };

    private doAcceptProjectRequest = (pjr, toRole) => {
        this.acceptProjectRequest = pjr;
        this.acceptProjectRole = toRole;
        ($('#acceptProjectRequestModal') as any).modal('show');
    };

    protected acceptProjectRequestConfirm = () => {
        ($('#acceptProjectRequestModal') as any).modal('hide');

        var userName = getFullName(this.acceptProjectRequest.user);
        var roleName = this.acceptProjectRole.roleName;

        this.projectService.addMember(
            this.project.unixName,
            this.acceptProjectRequest.user.id,
            { roles: this.acceptProjectRole.id })
            .then(
                () => {
                    var msg = this.gfTranslateService.translate('{{userName}} has been added to the project as a {{roleName}}',
                        { 'userName': userName, 'roleName': roleName });
                    this.uiService.message.showSuccess(msg);
                    this.acceptProjectRequest = false;
                    this.acceptProjectRole = false;
                    this.page_num = 1;
                    this.joinRequestPage = 1;
                    this.updateMembersList();
                    this.updateJoinRequestList();
                },
                () => {
                    var unixName = this.acceptProjectRequest.user.unixName;
                    var msg = this.gfTranslateService.translate('There was a problem adding {{unixName}} to the project',
                        { 'unixName': unixName });
                    this.uiService.message.showWarning(msg, 'Data error');
                    this.acceptProjectRequest = false;
                    this.acceptProjectRole = false;
                }
            );
    };

    private sendInvitation = () => {
        if (this.invites.invitedEmail === undefined || this.invites.invitedEmail === null || this.invites.invitedEmail === '') {
            this.uiService.message.showWarning(this.gfTranslateService.translate("You must enter an email address"));
            return;
        }

        if (this.inviteRole === undefined || this.inviteRole === null || this.inviteRole === '') {
            this.uiService.message.showWarning(this.gfTranslateService.translate("You have to select a role for the user"));
            return;
        }

        this.projectService.sendInvite(
            this.project.id,
            this.invites.invitedEmail,
            this.inviteRole
        ).then(
            (result) =>this.handleInviteResult(result),
            (result) => {
                this.uiService.message.showWarning(this.gfTranslateService.translate('There was a problem with the invite'),
                    'Data error');
            }
        );
    };

    private resendInvitation = (invitedUser) => {
        this.projectService.sendInvite(
            this.project.id,
            invitedUser.userEmail,
            invitedUser.roleId
        ).then(
            (result) => this.handleInviteResult(result),
            () => {
                var msg = this.gfTranslateService.translate('Sorry, could not re-send the invitation to {{userEmail}}',
                    { 'userEmail': invitedUser.userEmail });
                this.uiService.message.showWarning(msg, 'Data error');
            }
        );
    };

    private setSelectedRole = (event, member, rol) => {
        event.stopPropagation();
        if (rol.selected == true) {
            member.selectedRoles = _.without(member.selectedRoles, rol);
            rol.selected = false;
        } else {
            member.selectedRoles.push(rol);
            rol.selected = true;
        }
    };

    private toggleRoleDefinitions = () => {
        $('#role-info').slideToggle('slow');//jquery code
    };

    private updateMemberRoles = (user, roleToToggle) => {

        // Figure out if we're adding or removing a role
        if (this.isMemberInRole(user, roleToToggle)) {
            // We're removing a role - is it the last one for this user?
            if (user.roles.length == 1) {
                this.removeMember(user);
                return;
            }
            _.remove(user.roles, { id: roleToToggle.id });
        } else {
            if (!Array.isArray(user.roles)) {
                user.roles = [roleToToggle];
            } else {
                user.roles.push(roleToToggle);
            }
        }

        this.projectService.updateRoles(
            this.project.unixName,
            user.id,
            _.map(user.roles, (item) => { return item.id; }).join(',')
        ).then(
            () => {
                var msg = this.gfTranslateService.translate('Updated project roles for {{unixName}}',
                    { 'unixName': user.unixName });
                this.uiService.message.showSuccess(msg, 'Roles updated');
            },
            () => {
                var msg = this.gfTranslateService.translate('There was a problem adding roles');
                this.uiService.message.showWarning(msg, 'Data error');
                this.loadProjectMembers();
            }
        );
    };

    private memberRoleDisplay = (member) => {
        var ret = '';
        if (Array.isArray(member.roles)) {
            ret = _.map(member.roles, (item) => { return item.roleName; }).join(', ');
        }
        if (ret == '') {
            return this.gfTranslateService.translate('Roles') + '...';
        }
        return ret;
    };

    private isMemberInRole = (user, role) => {
        var roles = _.get(user, 'roles', []);
        if (_.find(roles, { id: role.id })) {
            return true;
        }
        return false;
    };

    private handleInviteResult(response) {
        if (Array.isArray(response)) {
            var anyExisting = false;
            var anySuccess = false;
            _.forEach(response, (result) => {
                if (result && result.success) {
                    if (result.user) {
                        var msg = this.gfTranslateService.translate("That email belongs to an existing user ({{unixName}}), " +
                            "now added to the project", result.user);
                        this.uiService.message.showSuccess(msg, this.gfTranslateService.translate('Existing User Added'));
                        anyExisting = true;
                    } else {
                        this.uiService.message.showSuccess(this.gfTranslateService.translate("The invitation was sent"));
                        anySuccess = true;
                    }
                } else {
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate('The invitation could not be sent') + ': ' + _.get(result, 'message', '(unknown error)'),
                        this.gfTranslateService.translate('Invitation Not Sent')
                    );
                }
            });
            if (anyExisting) {
                this.page_num = 1;
                this.updateMembersList();
            }

            this.updateInvitesList();
        }
        this.invites.invitedEmail = '';
    }

    private getRolesDropdown() {
        for (var member in this.members) {
            var memberRoles = this.members[member].roles;
            var rolesArray = [];
            this.members[member].selectedRoles = [];
            for (var rol in this.roles) {
                var filterparams = { id: this.roles[rol].id };
                var requestedRole = _.find(memberRoles, filterparams);
                if (requestedRole === undefined) {
                    rolesArray.push({
                        id: this.roles[rol].id,
                        roleName: this.roles[rol].roleName,
                        selected: false
                    });
                } else {
                    var object = {
                        id: this.roles[rol].id,
                        roleName: this.roles[rol].roleName,
                        selected: true
                    };
                    this.members[member].selectedRoles.push(object);
                    rolesArray.push(object);

                }
            }
            this.members[member].orderRoles = rolesArray;
        }
    }

    private updateJoinRequestList() {
        var options = {
            page_size: 50,
            page_num: this.joinRequestPage
        };
        this.getJoinRequests(options);
    }

    private getJoinRequests(options) {
        var searchJoinRequestPromise = this.projectService.joinRequests(this.project.unixName, options)
            .then(
                (response: any) => {
                    this.joinRequests = response.items;
                    this.joinRequestPage = 1;
                },
                (response) => {
                    this.uiService.message.showWarning(this.gfTranslateService.translate('There was a problem loading join requests'),
                        'Data Error');
                }
            );
        return searchJoinRequestPromise;
    }

    private updateInvitesList() {
        var options = {
            page_size: 50,
            page_num: this.invitesPage
        }
        this.getInvites(options);
    }

    private updateMembersList() {
        this.members = false;

        this.projectService.members(this.project.unixName, this.getMembersListOptions())
            .then((response) => {
                this.members = _.get(response, 'items', []);
                //getRolesDropdown();
            }, () => {
                var msg = this.gfTranslateService.translate('There was a problem loading project members: {{unixName}}',
                    { 'unixName': this.project.unixName });
                this.uiService.message.showWarning(msg, 'Data Error');
                this.members = [];
            });
    }

    private getMembersListOptions() {
        return {
            page_num: this.stateService.params.page_num,
            page_size: this.stateService.params.page_size,
            search: this.stateService.params.search,
            role: this.stateService.params.role,
            groups: true,
            group: true,
            rel: 'roles,groups'
        };
    }

    protected loadProjectMembers() {
        return new Promise(
            (resolve, reject) => {
                this.projectService.members(this.project.unixName, this.getMembersListOptions())
                    .then(
                        (response: any) => {
                            this.members = response.items;
                            this.page_num = 1;
                            resolve(response);
                        },
                        () => {
                            reject();
                        }
                    );
            }
        );
    }

    private getInvites(options) {
        var searchInvitesPromise = this.projectService.invites(this.project.unixName, options)
            .then(
                (response: any) => {
                    this.invitedUsers = _.map(response.items, (item) => {
                        var role = this.roles.find((role) => {
                            return (role.id == item.roleId);
                        });
                        item.role = role;
                        return item;
                    });
                    this.invitesPage = 1;
                },
                () => {
                    var msg = this.gfTranslateService.translate('There was a problem loading invited users: {{unixName}}',
                        { 'unixName': this.project.unixName });
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
        return searchInvitesPromise;
    }
}